import Image from 'next/image';
import { eePromoImpHandler, setPromoDetailsCookie } from '@utils/gtm';
import { LinkTile, PageType } from '@adapters/prismic/types/slices';
import { useEffect, useMemo, useRef } from 'react';
import useObjectVisibility from '@hooks/useObjectVisibility';
import { useLocale } from '@hooks/useLocale';
import styles from './LinkTiles.module.scss';

export interface LinkTilesItemProps {
  image: LinkTile['tile_image'];
  link: LinkTile['tile_link'];
  trackPromos?: boolean;
  pageType: PageType;
  positionWithinSlice: number;
  sliceIndex: number;
}

const LinkTilesItem = ({
  image,
  link,
  trackPromos,
  pageType,
  positionWithinSlice,
  sliceIndex,
}: LinkTilesItemProps) => {
  const locale = useLocale();
  const ref = useRef<any>(null);
  const isVisible = useObjectVisibility(ref);

  const promoDetails = useMemo(
    () => ({
      id: image.alt,
      name: image.alt,
      type: 'image',
      url: link.url,
      position: `${pageType}-${sliceIndex}-LinkTile-${positionWithinSlice}`,
    }),
    [image.alt, link.url, pageType, positionWithinSlice, sliceIndex]
  );

  useEffect(() => {
    if (trackPromos && isVisible) {
      eePromoImpHandler(promoDetails);
    }
  }, [isVisible, promoDetails, trackPromos]);

  return (
    <div
      className={styles.linkTileItemWrapper}
      key={`link-tile-wrapper-${image.url}`}
    >
      <div className={styles.linkTileItem} key={`link-tile-${image.url}`}>
        {link.url ? (
          <a
            href={`/${locale}${link.url}`}
            ref={ref}
            onClick={
              trackPromos
                ? () => setPromoDetailsCookie(promoDetails)
                : undefined
            }
          >
            <Image
              src={image.url}
              alt={image.alt}
              quality={65}
              fill
              sizes="(min-width: 720px) 384px, 256px"
            />
          </a>
        ) : (
          <Image
            src={image.url}
            alt={image.alt}
            quality={65}
            fill
            sizes="(min-width: 720px) 384px, 256px"
          />
        )}
      </div>
    </div>
  );
};

export default LinkTilesItem;
